module.exports = __webpack_public_path__ + "img/icon-edit.b87f8158.svg";